// extracted by mini-css-extract-plugin
export default {"top":"MainTop_top__HQRmm","right":"MainTop_right__0k0Fi","chatName":"MainTop_chatName__ZYE+F"};